/** Session key for unified admin dashboard (APP_SECRET via ?auth_token=). Never logged. */
export const ADMIN_AUTH_TOKEN_STORAGE_KEY = "clumse_admin_auth_token";

/**
 * True if the current address bar includes a non-empty `?auth_token=` (or legacy `?secret=`)
 * on first paint, before {@link consumeAdminAuthTokenFromUrl} strips the query.
 */
export function readUrlHadNonemptyAdminAuthToken() {
  if (typeof window === "undefined") return false;
  try {
    const params = new URLSearchParams(window.location.search);
    return (
      (params.get("auth_token") || params.get("secret") || "").trim().length > 0
    );
  } catch {
    return false;
  }
}

/**
 * Read `?auth_token=` (or legacy `?secret=`) from URL, persist to sessionStorage,
 * strip from address bar, else reuse sessionStorage.
 */
export function consumeAdminAuthTokenFromUrl() {
  if (typeof window === "undefined") return "";
  try {
    const params = new URLSearchParams(window.location.search);
    const q = (params.get("auth_token") || params.get("secret") || "").trim();
    if (q) {
      sessionStorage.setItem(ADMIN_AUTH_TOKEN_STORAGE_KEY, q);
      window.history.replaceState(
        {},
        document.title,
        `${window.location.pathname}${window.location.hash || ""}`
      );
      return q;
    }
    return (sessionStorage.getItem(ADMIN_AUTH_TOKEN_STORAGE_KEY) || "").trim();
  } catch {
    return (sessionStorage.getItem(ADMIN_AUTH_TOKEN_STORAGE_KEY) || "").trim();
  }
}

export function clearAdminAuthToken() {
  if (typeof window === "undefined") return;
  try {
    sessionStorage.removeItem(ADMIN_AUTH_TOKEN_STORAGE_KEY);
  } catch {
    /* ignore */
  }
}
